import React from 'react';

import PropTypes from 'prop-types';

const IconPanel = ({ color = '#4285F4', height = '10em', width = '10em' }) => (
    <svg
        width={width}
        height={height}
        viewBox="0 0 512 515"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <circle cx="264" cy="252" r="248" fill="white" />
        <circle cx="248" cy="248" r="246" stroke={color} strokeWidth="4" />
        <path d="M86 388.969V122L393.014 193.192V388.969H86Z" fill="#E9ECF5" />
        <path
            d="M101.986 388.969V122L409 193.192V388.969H101.986Z"
            stroke="black"
            strokeWidth="7.99307"
            strokeLinejoin="round"
        />
        <path
            d="M419.2 199.621L87.5601 124.852C86.6479 124.646 86 123.836 86 122.901V110.506C86 109.223 87.1922 108.271 88.4439 108.556L424.242 184.986C425.432 185.257 426.104 186.521 425.663 187.659L421.505 198.392C421.147 199.316 420.166 199.839 419.2 199.621Z"
            fill={color}
        />
    </svg>
);

IconPanel.propTypes = {
    color: PropTypes.string,
    height: PropTypes.string,
    width: PropTypes.string,
};

export default IconPanel;
